<template>
	<form class="form-component" @submit.prevent="saveInformation">
		<div class="wrapper-loading" v-if="showloading">
			<div class="wrapper-opacity"></div>
			<div class="loading">
				<v-progress-circular
					:size="70"
					:width="7"
					indeterminate
					color="teal darken-1">
				</v-progress-circular>
			</div>
		</div>
		<v-layout row wrap class="contact-form">
			<v-flex xs12>
				<p class="text-title">Participa del Próximo Demo</p>
			</v-flex>
			<v-flex xs12>
				<v-select
					:class="{'is-selected-active' : model.date}"
					:items="days"
					placeholder="Seleccione un día"
					class="input-component"
					item-text="name"
					item-value="name"
					hide-details
					single-line
					v-model="model.date"
					@input="onSelectedDate"
				></v-select>
			</v-flex>
			<v-flex v-if="model.date" class="br-mobile">
				<v-select
					:class="{'is-selected-active' : model.date}"
					:items="hourSelected"
					placeholder="Seleccione un horario"
					class="input-component"
					item-text="hour"
					item-value="hour"
					hide-details
					single-line
					:return-object="false"
					v-model="model.hour"
					@input="setHour"
				></v-select>
			</v-flex>
			<v-flex xs12 v-if="model.date" class="br-desktop">
				<v-radio-group v-model="model.hour" row>
					<v-layout row align-center>
						<v-radio
						v-for="(item, index) in hourSelected"
						:key="index"
						:value="item.hour"
						:label="item.hour">
						</v-radio>
					</v-layout>
				</v-radio-group>
			</v-flex>
			<v-flex xs12>
				<v-layout>
					<v-flex x5>
						<v-select
							class="input-component"
							label="Tu país"
							v-model="model.country"
							item-text="value"
							item-value="value"
							:items="countries"
							hide-details
							single-line
						>
						<template slot="selection" slot-scope="data">
								<div>
									<img
										:src="data.item.image"
										:alt="data.item.name"
										height="20">
									<span>{{data.item.value}}</span>
								</div>
							</template>
							<template slot="item" slot-scope="data">
								<div>
									<img
										:src="data.item.image"
										:alt="data.item.name"
										height="20">
									<span>{{data.item.value}}</span>
								</div>
							</template>
						</v-select>
					</v-flex>
					<v-flex xs7 pl-2>
						<input
						type="number"
						placeholder="Ingrese tu celular"
						class="input-component mb-0"
						v-model="model.phone">
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 px-2 pt-4>
				<button
					class="btn-form"
					:disabled="!disabled || loading"
					type="submit">QUIERO PARTICIPAR</button>
			</v-flex>
		</v-layout>
	</form>
</template>
<script>
function created() {
	if (this.$route.query.number) {
		const number = this.$route.query.number.split('-');
		this.model.phone = number[1];
		this.model.country = `+${number[0]}`;
	} else {
		this.model.country = '+51';
	}
}

function disabled() {
	const phonePer = this.model.phone.length > 7 && this.model.phone.length < 11;
	return this.model.date && this.model.phone &&
		this.model.hour && phonePer;
}

async function saveInformation() {
	this.showloading = true;
	this.loading = true;
	const body = {
		companyId: process.env.COMPANY_ID_APP,
		data: {
			message: 'Reserva Realizada',
			phone: this.adviser.number,
			fields: {
				asesor: this.adviser.name,
				fecha: this.model.date,
				hora: this.model.hour,
				phone: this.model.phone,
			},
		},
		flagMailValid: true,
		templateCode: process.env.TEMPLATE_ASESOR,
		sheetId: this.adviser.sheetId,
	};
	const prefix = this.countries.findIndex(c => c.value === this.model.country);
	if (prefix > -1) {
		body.data.fields.phone = `${this.countries[prefix].value}${body.data.fields.phone}`;
	}
	try {
		await this.$httpNotification.post('notifications/WMAKI/public', body);
		this.showNotification('Gracias por participar, sus datos fueron guardados correctamente.');
	} catch (err) {
		this.showGenericError();
	} finally {
		this.showloading = false;
		this.loading = false;
	}
}

function prefixPhone() {
	let prefix = '51';
	const index = this.countries.findIndex(c => c.value === this.model.country);
	if (index > -1) {
		prefix = this.countries[index].phone;
	}
	return prefix;
}

function clearForm() {
	this.model = {
		date: '',
		phone: '',
		hour: '',
	};
}

function onSelectedDate(name) {
	const index = this.adviser.day.findIndex(c => c.name.toUpperCase() === name.toUpperCase());
	if (index > -1) {
		this.hourSelected = this.adviser.day[index].rangeHours;
	}
}

function setHour(value) {
	this.model.hour = value;
}

function data() {
	return {
		model: {
			phone: '',
			date: '',
			hour: '',
			country: 'Peru',
		},
		loading: false,
		message: false,
		caption: '',
		showloading: false,
		countries: [
			{
				id: 1,
				value: '+51',
				name: 'Peru',
				image: '/static/images-new/banners/peru.svg',
				phone: '51',
			},
			{
				id: 2,
				value: '+593',
				name: 'Ecuador',
				image: '/static/images-new/banners/ecuador.svg',
				phone: '593',
			},
			{
				id: 3,
				value: '+56',
				name: 'Chile',
				image: '/static/images-new/banners/chile.svg',
				phone: '56',
			},
			{
				id: 4,
				value: '+57',
				name: 'Colombia',
				image: '/static/images-new/banners/colombia.svg',
				phone: '57',
			},
			{
				id: 5,
				value: '+591',
				name: 'Bolivia',
				image: '/static/images-new/banners/bolivia.svg',
				phone: '91',
			},
		],
		days: [
			{
				id: 1,
				name: 'Lunes',
			},
			{
				id: 2,
				name: 'Martes',
			},
			{
				id: 3,
				name: 'Miercoles',
			},
			{
				id: 4,
				name: 'Jueves',
			},
			{
				id: 5,
				name: 'Viernes',
			},
			{
				id: 6,
				name: 'Sabado',
			},
		],
		hourSelected: [],
	};
}
export default {
	name: 'form-component',
	data,
	created,
	computed: {
		disabled,
		prefixPhone,
	},
	methods: {
		onSelectedDate,
		saveInformation,
		clearForm,
		setHour,
	},
	props: {
		adviser: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.form-component {
		background: color(white);
		box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.08);
		border-radius: 8px;
		margin-left: auto;
		padding-top: 35px;
		max-width: 420px;
		overflow: hidden;
		position: relative;
		z-index: 1;

		@media (max-width: 936px) {
			margin-bottom: 20px;
			max-width: 100%;
			padding-top: 28px;
			width: 100%;
		}
	}

	.title-form {
		color: color(green-dark);
		font-weight: map-get($weight, w800);
		font-size: size(large27);
		text-align: center;

		&.desktop {
			@media (max-width: 936px) {
				display: none;
			}
		}

		&.mobile {
			@media (min-width: 936px) {
				display: none;
			}
		}
	}

	.subtitle-form {
		color: color(form-grey);
		font-size: size(medium18);
		text-align: center;
	}

	.input-component {
		border: 1px solid color(gray-footer);
		border-radius: 8px;
		height: 40px;
		margin-bottom: 10px;
		padding: 0 15px;
		width: 100%;

		&:focus {
			outline: 0px;
		}

		@media (max-width: 936px) {
			border-radius: 3px;
			height: 50px;
		}
	}

	.is-selected-active {
		color: #ff5c00 !important;
	}

	.btn-form {
		background: color(newprimary);
		border-radius: 9px;
		color: color(white);
		font-size: size(medium18);
		font-weight: map-get($weight, w900);
		margin-bottom: 36px;
		padding: 10px 35px;
		width: 100%;

		@media (max-width: 936px) {
			margin-top: 14px;
			padding: 14px 35px;
		}
	}

	.font-green {
		color: color(title-green);
	}

	.font11 {
		color: color(form-gray);
		font-size: size(medium);
	}

	.contact-form {
		padding: 37px 45px 0px;

		@media (max-width: 936px) {
			padding: 15px 15px 0px;
		}
	}

	.footer-form {
		background: map-get($colors, title-green);
		border-radius: 0 0 8px 8px;
		color: map-get($colors, white);
		padding: 15px 0;

		@media (max-width: 936px) {
			border-radius: 0;
		}
	}

	.wrapper-btn {
		padding: 20px 42px 0px;

		@media (max-width: 936px) {
			padding: 15px 50px 0px;
		}
	}

	.btn-not-available {
		border: 1px solid map-get($colors, title-green);
		border-radius: 2px;
		color: map-get($colors, title-green);
		height: 100%;
		padding: 8px 11px;
		text-align: center;
		width: 100%;
	}

	.btn-available {
		background: map-get($colors, title-green);
		border-radius: 2px;
		color: map-get($colors, white);
		display: block;
		height: 100%;
		padding: 8px 11px;
		text-align: center;
		width: 100%;
	}

	.wrapper-message {
		background: map-get($colors, white);
		bottom: 0;
		border-radius: 9px;
		height: 100%;
		padding-top: 40%;
		position: absolute;
		left: 0;
		right: 0;
		text-align: center;
		top: -100%;
		transition: all 0.5s ease;
		z-index: 1;

		&.open {
			top: 0;
		}
	}

	.message-text {
		color: map-get($colors, title-green);
		font-size: map-get($sizes, large);
	}

	.message-information {
		color: map-get($colors, form-grey);
		font-size: map-get($sizes, medium16);
	}

	.wrapper-loading {
		align-items: center;
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
	}

	.wrapper-opacity {
		background-color: color(white);
		bottom: 0;
		left: 0;
		opacity: 0.5;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 1;
	}

	.loading {
		position: absolute;
		z-index: 2;
	}

	.center {
		text-align: center;
	}

	.text-warehouse {
		background: color(back-gray-l);
		border: 1px solid color(border-l);
		border-radius: 8px;
		color: color(title-green);
		font-weight: 600;
		margin: auto;
		padding: 10px 0;
		width: 220px;
	}

	.text-info {
		color: color(caption);
    	font-size: 12px;
	}

	.text-title {
		color: color(primary);
		font-size: size(large25);
		font-weight: 700;
		text-align: center;

		@media (max-width: 936px) {
			font-size: 17px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/advisers/form-asesor.vue